export default "__VITE_ASSET__CIvt86AK__"